import './bordered-text-block.pcss';
import './bordered-text-block';